import { render, staticRenderFns } from "./CustomSeparator.vue?vue&type=template&id=2ad31f80&scoped=true"
import script from "./CustomSeparator.vue?vue&type=script&lang=js"
export * from "./CustomSeparator.vue?vue&type=script&lang=js"
import style0 from "./CustomSeparator.vue?vue&type=style&index=0&id=2ad31f80&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad31f80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ad31f80')) {
      api.createRecord('2ad31f80', component.options)
    } else {
      api.reload('2ad31f80', component.options)
    }
    module.hot.accept("./CustomSeparator.vue?vue&type=template&id=2ad31f80&scoped=true", function () {
      api.rerender('2ad31f80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CustomSeparator.vue"
export default component.exports